import { gql, useMutation } from '@apollo/client';

const BATCH_TRIGGER_PENDING_SNIPPETS = gql`
  mutation BatchTriggerPendingSnippets {
    batchTriggerPendingSnippets
  }
`;

export interface BatchTriggerPendingSnippetsData {
  batchTriggerPendingSnippets: string;
}

export function useBatchTriggerPendingSnippetsMutation() {
  return useMutation<BatchTriggerPendingSnippetsData>(BATCH_TRIGGER_PENDING_SNIPPETS);
}
